import { useNavigate, useSearchParams } from 'react-router-dom';
import { ReactNode } from 'react';
import { Icon } from '../icon/Icon';
import { TabRoute, TabValueType } from '../tabs/interfaces';
import { TabHead } from '../tabs/TabHead';
import { TabLabel } from '../tabs/TabLabel';
import { TabPanel } from '../tabs/TabPanel';
import { TabProvider } from '../tabs/Tabs';
import { EntityListContainerHeader } from './EntityListContainerHeader';

export function EntityListContainer({
  tabs,
  defaultTab,
  title,
  description,
  endAdornment
}: {
  tabs: TabRoute<unknown>[];
  defaultTab: TabValueType;
  title: string;
  description: string;
  endAdornment?: ReactNode;
}) {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const currentTab = searchParams.get('tab') || defaultTab;

  return (
    <div className='position-relative h-100 w-100 bg-surface overflow-auto flex-col'>
      <TabProvider
        defaultTab='configuration'
        currentTab={currentTab}
        onClick={value => {
          navigate({
            search: new URLSearchParams({ tab: value as string }).toString()
          });
        }}
      >
        <EntityListContainerHeader
          className={tabs.length <= 1 ? 'border-bottom' : ''}
          title={title}
          description={description}
          endAdornment={endAdornment}
        />

        <div>
          {tabs.length > 1 ? (
            <TabHead isScrollable compact>
              {tabs.map(tabRoute => (
                <TabLabel
                  compact
                  key={tabRoute.route}
                  value={tabRoute.route}
                  label={
                    <>
                      {tabRoute.icon ? (
                        <Icon name={tabRoute.icon} className='mr-2' size={1} />
                      ) : null}
                      <span>{tabRoute.label}</span>
                    </>
                  }
                />
              ))}
            </TabHead>
          ) : null}
        </div>

        <div className='flex-1 mt-3'>
          {tabs.map(tab => (
            <TabPanel key={tab.route} value={tab.route} activeTabClassName='h-100'>
              <tab.Component />
            </TabPanel>
          ))}
        </div>
      </TabProvider>
    </div>
  );
}
